<template>
<div class="navbar">
  <div class="navbar-logo">
    <img alt="Vidolia" src="../assets/LOGO.svg">
  </div>

  <div class="navbar-left">
    <a href="//store.vidolia.net">
      <le-button>
      <template #icon>
        <i class="fa-solid fa-wallet"></i>
      </template>
      Донат
    </le-button>
    </a>
    
  </div>

  <div class="navbar-right">
    <a href="https://store.steampowered.com/app/4000/Garrys_Mod/">
      <LeButton>
      <template #icon>
        <i class="fa-solid fa-cart-shopping"></i>
      </template>
      Купить Minecraft
    </LeButton>
    </a>
    
    <LeButton class="is-white-hl">
      <template #icon>
        <i class="fa-solid fa-right-to-bracket"></i>
      </template>
      Войти на сервер</LeButton>
  </div>
</div>
</template>

<style lang="sass">
.navbar
  min-width: 708px
  display: inline-flex
  justify-content: space-between
  position: sticky
  top: 38px
  bottom: 50px
  padding: 15px
  z-index: 999


  border-radius: var(--radius-lg, 10px)
  border: 1px solid var(--white-white-8, rgba(255, 255, 255, 0.08))
  background: rgba(255, 255, 255, 0.02)
  backdrop-filter: blur(25px)

  .le-button
    margin: 0 5px

  &-right
    margin-left: auto

  &-logo
    display: inline-flex
    img
      margin: auto
</style>

<script>
import LeButton from "@/components/LeButton.vue";

export default {
  name: "VidoliaBar",

  components: {
    LeButton
  }
}
</script>